import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["containerId", "providerId", "onStatusChange", "styles", "lang", "apiVersion", "amount", "currency", "skip3DS"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { arrayOf, bool, oneOf, shape, string, number } from 'prop-types';
import useGuestyPay from "../../hooks/useGuestyPay";
import Spinner from "../Spinner";
var widgetStyles = {
  root: {
    position: 'relative',
    width: '100%'
  },
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  }
};
var GuestyPayWidget = function GuestyPayWidget(_ref) {
  var _ref$containerId = _ref.containerId,
    containerId = _ref$containerId === void 0 ? 'guesty-tokenization-form-container' : _ref$containerId,
    providerId = _ref.providerId,
    onStatusChange = _ref.onStatusChange,
    styles = _ref.styles,
    lang = _ref.lang,
    apiVersion = _ref.apiVersion,
    amount = _ref.amount,
    currency = _ref.currency,
    skip3DS = _ref.skip3DS,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isIFrameLoading = _useState2[0],
    setIsIFrameLoading = _useState2[1];
  var guestyTokenization = useGuestyPay();
  useEffect(function () {
    (function () {
      var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return guestyTokenization.render(_extends({
                containerId: containerId,
                providerId: providerId,
                onStatusChange: onStatusChange,
                styles: styles,
                lang: lang,
                apiVersion: apiVersion,
                amount: amount,
                currency: currency,
                skip3DS: skip3DS
              }, props));
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 8:
              _context.prev = 8;
              setIsIFrameLoading(false);
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5, 8, 11]]);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    })()();
    return function () {
      guestyTokenization.destroy();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    style: widgetStyles.root,
    "data-qa": "guesty-pay-widget"
  }, isIFrameLoading && /*#__PURE__*/React.createElement("div", {
    style: widgetStyles.loaderContainer
  }, /*#__PURE__*/React.createElement(Spinner, null)), /*#__PURE__*/React.createElement("div", {
    id: containerId
  }));
};
GuestyPayWidget.propTypes = {
  /** Id of a payment provider, for which payment method is created */
  providerId: string.isRequired,
  /** Show supported cards component */
  showSupportedCards: bool,
  /** Show PCI compliant secure payment link */
  showPciCompliantLink: bool,
  /** Show checkboxes to toggle initial values */
  showInitialValuesToggle: bool,
  /** Label of the checkboxes to toggle initial values */
  initialValuesToggleLabel: string,
  /** Form initial values */
  initialValues: shape({
    firstName: string,
    lastName: string,
    street: string,
    city: string,
    state: string,
    zipCode: string,
    country: shape({
      value: string,
      label: string
    })
  }),
  /** Form sections to render. Used to change order. Default: ["cardholderName", "paymentDetails", "billingAddress"] */
  sections: arrayOf(oneOf(['billingAddress', 'cardholderName', 'paymentDetails'])),
  /** Initial values toggle checkbox config per section */
  sectionsConfig: shape({
    billingAddress: shape({
      showInitialValuesToggle: bool,
      initialValuesToggleLabel: string
    }),
    cardholderName: shape({
      showInitialValuesToggle: bool,
      initialValuesToggleLabel: string
    })
  }),
  /** Form styles overrides */
  styles: shape({
    mobileBreakpoint: number,
    fontFamily: string,
    fontSizeMd: number,
    fontSizeLg: number,
    fontWeightRegular: number,
    fontWeightBold: number,
    colorText: string,
    colorTextError: string,
    colorPlaceholder: string,
    colorBorder: string,
    colorBorderError: string,
    colorBorderHover: string,
    colorBackgroundError: string,
    colorBackgroundDisabled: string
  }),
  /** Api version for tokenization. */
  apiVersion: string,
  /** Amount of the future payment. */
  amount: number,
  /** Currency code of the future payment. */
  currency: string,
  /** Flag to skip 3DS process */
  skip3DS: bool
};
export default GuestyPayWidget;